import { Navigate, useSearchParams } from 'react-router-dom';

const IncidentsCreateRedirect = () => {
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get('order_id');
    const next = new URLSearchParams();
    next.set('openCreateIncident', 'true');
    if (orderId) {
        next.set('order_id', orderId);
    }
    return (
        <Navigate
            to={`/logistic-management/incidents/?${next.toString()}`}
            replace
        />
    );
};

export { IncidentsCreateRedirect };
